import { ClientPaymentPlan, ClientPaymentPlanOrgs, PaymentPlan, ProgramType } from 'types';

import { api } from './api';

export const paymentPlansApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPaymentPlans: build.query<ClientPaymentPlan[], { programType: ProgramType }>({
      query: ({ programType }) => ({ url: `payment-plans?programType=${programType}` }),
      providesTags: (_result, _error) => {
        return [{ type: 'PaymentPlans', id: 'LIST' }];
      },
    }),
    getPaymentPlan: build.query<ClientPaymentPlan, { id: string }>({
      query: ({ id }) => ({ url: `payment-plans/${id}` }),
      providesTags: (result, _error) => {
        return [{ type: 'PaymentPlans', id: result?.id }];
      },
    }),
    getPaymentPlanOrgs: build.query<ClientPaymentPlanOrgs[], { id: string }>({
      query: ({ id }) => ({ url: `admin/payment-plan/${id}/orgs` }),
      providesTags: (_result, _error) => {
        return [{ type: 'PaymentPlansOrgs', id: 'LIST' }];
      },
    }),
    createPaymentPlan: build.mutation<ClientPaymentPlan, PaymentPlan>({
      query: (body) => ({ url: `payment-plans`, method: 'POST', body }),
      invalidatesTags: [{ type: 'PaymentPlans', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetPaymentPlansQuery,
  useGetPaymentPlanQuery,
  useGetPaymentPlanOrgsQuery,
  useCreatePaymentPlanMutation,
} = paymentPlansApi;
